import { render, staticRenderFns } from "./Minus.vue?vue&type=template&id=6ce46f5c&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ce46f5c')) {
      api.createRecord('6ce46f5c', component.options)
    } else {
      api.reload('6ce46f5c', component.options)
    }
    module.hot.accept("./Minus.vue?vue&type=template&id=6ce46f5c&", function () {
      api.rerender('6ce46f5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/Minus.vue"
export default component.exports